import React, {useState,useEffect,useRef} from 'react';
import '../../CSS/index.css';
import { connect } from 'react-redux';
import Highlighter from 'react-highlight-words';
import { getList } from '../../Utils/FormCalls';
import { StyledFormType } from '../../CSS/style';
import { SearchOutlined } from '@ant-design/icons';
import { Button, Input, Tooltip } from 'antd';
import { RBSPREDMODEL } from '../../../../commons/api';
import StyledTable from '../../../../commons/styles/table';
import themeSettings from '../../../../commons/styles/themeSettings.json';
const APIList = {
  getList: `${RBSPREDMODEL.StagingmetadataList}`
};
const ModelRegistrations = (props) => {
  const [dataSource, setDataSource] = useState([]);
  const [translationCache, setTranslationCache] = useState(props);
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef(null);
  useEffect(() => {
    const fetchData = async () => {
      let response = await getList(APIList.getList);
      setDataSource(response && Array.isArray(response) ? [...response] : []);
    };
    fetchData();
  }, []);
  useEffect(() => {
    if (props.translationCache) {
      setTranslationCache(props.translationCache);
    }
  }, [props.translationCache]);
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={translation('Search') + translation(dataIndex)}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          
          style={{
            width: 90,
            marginRight: '5px'
          }}
        >
          {translation('Search')}
        </Button>
        <Button
          onClick={() => clearFilters && handleReset(clearFilters, confirm)}
          
          style={{ width: 90 }}
        >
          {translation('Reset')}
        </Button>
        {/* <Button
          type="link"
          
          onClick={() => {
            confirm({
              closeDropdown: false,
            });
            this.setState({
              searchText: selectedKeys[0],
              searchedColumn: dataIndex,
            });
          }}
        >
          Filter
        </Button> */}
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current.select());
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) : (
        text
      )
  });
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    confirm();
    setSearchText('');
  };
  const translation = (keyword) => {
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };
  const columns = [
    {
      title: translation('Group'),
      dataIndex: 'ModelGroup',
      key: 'ModelGroup',
      ...getColumnSearchProps('ModelGroup'),
      sorter: (a, b) => a.ModelGroup.localeCompare(b.ModelGroup)
    },
    {
      title: translation('Model Name'),
      dataIndex: 'ModelName',
      key: 'ModelName',
      ...getColumnSearchProps('ModelName'),
      sorter: (a, b) => a.ModelName.localeCompare(b.ModelName)
    },
    {
      title: translation('Status'),
      dataIndex: 'Status',
      key: 'Status',
      ...getColumnSearchProps('Status'),
      defaultFilteredValue: ['unregistered'],
      sorter: (a, b) => a.Status.localeCompare(b.Status)
    },
    {
      title: translation('Action'),
      render: (text, record) => (
        <Tooltip
          title={
            record.Status === 'Deployed' || record.Status === 'Registered'
              ? translation('Open Details')
              : translation('Click to Register')
          }
        >
          <a
            style={{ marginRight: '5px' }}
            onClick={() =>
              record.Status === 'Deployed' || record.Status === 'Registered'
                ? props.navigate(`/rubus/RbsAnalytics/ModelDetails/${record.ModelId}`)
                : props.navigate(`/rubus/RbsAnalytics/RegisterModel/${record.ModelName}`)
            }
          >
            {record.Status === 'Deployed' || record.Status === 'Registered'
              ? translation('Details')
              : translation('Register')}
          </a>
        </Tooltip>
      )
    }
  ];
    return (
      <>
        <StyledFormType theme={themeSettings}>
          {translation('Models From Staging Area')}
        </StyledFormType>
        <StyledTable size="small"
          dataSource={Array.isArray(dataSource) ? dataSource.map((data, index) => ({ ...data, key: index })) : []}
          columns={columns}
       />
      </>
    );
};
const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache
});
export default connect(mapStateToProps)(ModelRegistrations);
